module.exports = __webpack_public_path__ + "media/images/emblems/Attiswil-coat_of_arms-b4a2d3be559974108529e7b3945f0e40.svg";